// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OdhP","field":"styles_field__PgMaH","fieldCol":"styles_fieldCol__2szyc","diffCol":"styles_diffCol__2EfKN","diff":"styles_diff__2JpSS"};